import type { TRuleWithTheme } from '@/styles/theme';

export const form: TRuleWithTheme = () => ({
    min1024: {
        flexGrow: 1,
        overflow: 'auto',
    },
});
